var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[(_vm.show)?_c('canvas',{staticStyle:{"display":"block"},attrs:{"id":_vm.conduitInfo.id}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }